angular
  .module('workflow')

  .factory('TaskCountersCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class TaskCountersCrud extends Crud {
        constructor() {
          super(
            '',
            '@@apiUrl' + '/tasks-counters' + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: false
              }
            }
          );
        }
      }
      return TaskCountersCrud;
    }
  ]);
